import React from 'react';

import TableCalls from "./Table/TableCalls.js";
import MyAppBar from "../MyAppBar/MyAppBar.js";

export default function Contacts() {
    return (
        <>
            < MyAppBar />
            < TableCalls />
        </>
    );
}
